var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadingComplete)?_c('div',{staticClass:"slim-page slim-page-mt"},[_c('vap-card',[_c('label',[_vm._v(_vm._s('Thank you'))]),_c('br'),_c('label',[_vm._v(_vm._s('This form is already completed'))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }